import { useQuery } from '@tanstack/react-query'
import api from '@/admin/lib/api'
import type {
  ApiLogDetail,
  ApiLogFilters,
  ApiLogListResponse,
} from '@/admin/types/api-logs'

const LIST_KEY = (filters: ApiLogFilters) => ['api-logs', filters] as const
const DETAIL_KEY = (uuid: string | null) => ['api-logs', 'detail', uuid] as const

export function useApiLogs(filters: ApiLogFilters = {}) {
  return useQuery<ApiLogListResponse>({
    queryKey: LIST_KEY(filters),
    queryFn: () =>
      api
        .get('/public-api-logs/', { params: stripEmpty(filters) })
        .then((r) => r.data),
    // Short staleTime - the live pulse indicator promises near-real-time.
    staleTime: 2_000,
    refetchInterval: 5_000,
  })
}

export function useApiLogDetail(uuid: string | null) {
  return useQuery<ApiLogDetail>({
    queryKey: DETAIL_KEY(uuid),
    queryFn: () => api.get(`/public-api-logs/${uuid}/`).then((r) => r.data),
    enabled: uuid !== null,
    staleTime: 60_000,
  })
}

function stripEmpty(obj: Record<string, string | undefined>) {
  const out: Record<string, string> = {}
  for (const [k, v] of Object.entries(obj)) {
    if (v) out[k] = v
  }
  return out
}
